<template>
  <RF-Dialog
    :cpntStatus='""'
    :cpntTitulo="cpntTitulo"
    :cpntStatusImprimir="true"
    :cpntLargura='cpntTamanho'>
      <template slot='conteudo'>
        <slot name="acima-barra"></slot>

        <div class="rf-progress-bar-valor">{{ cpntProgres }} % </div>
        <b-progress class="rf-progress-bar" :height="cpntHeight" :value="Number(cpntProgres)" :max="100" :class="cpntClass" animated></b-progress>

        <slot name="abaixo-barra"></slot>
      </template>
  </RF-Dialog>
</template>

<style>
  .rf-progress-bar {
    margin: 0px;
    margin-top: 10px;
  }
  .rf-progress-bar-valor {
    position: absolute;
    left: 50%;
    text-align: center;
    text-shadow: none;
    font-weight: bold;
    margin-top: 13px;
    width: 62px;
    margin-left: -31px;
  }
</style>

<script>
  export default {
    props: {
      cpntTitulo: {
        required: false,
        type: String,
        default: function () {
          return 'Abrindo...'
        }
      },
      cpntProgres: {
        required: true,
        type: [ Number, String ]
      },
      cpntHeight: {
        required: true,
        type: String,
        default: function () {
          return '5px'
        }
      },
      cpntClass: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return [ 'mb-2' ]
        }
      },
      cpntTamanho: {
        required: false,
        type: String,
        default: function () {
          return '600px'
        }
      }
      // cpntOnFecharDialog: {
      //   required: true
      // }
    }
  }
</script>
